exports = module.exports = require("../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dnd-drag-start {\n    transform:scale(0.8);\n    opacity:0.7;\n    border: 2px dashed #000;\n}\n\n.dnd-drag-enter {\n    opacity:0.7;\n    border: 2px dashed #000;\n}\n\n.dnd-drag-over {\n    border: 2px dashed #000;\n}\n\n.dnd-sortable-drag {\n  transform:scale(0.9);\n  opacity:0.7;\n  border: 1px dashed #000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./~/ng2-dnd/style.css
// module id = 812
// module chunks = 3